import { Progress } from '@agro-club/agroclub-shared'
import { refetchFunc, useSingleEntity, useTableData } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { createContext, useMemo } from 'react'
import { useParams } from 'react-router'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { SellerSpec, SpecificationsForPurchase } from 'modules/domain/deal/types'
import { useDealContext } from './DealContext'

interface SpecsContextType {
  sellerSpecInfo: {
    data: SellerSpec[]
    progress: Progress
    refetch: refetchFunc
  }
  customerSpecInfo: {
    data: SpecificationsForPurchase[]
    progress: Progress
    refetch: refetchFunc
  }
}

export const SpecsContext = createContext<SpecsContextType>({
  sellerSpecInfo: {
    data: [],
    progress: Progress.IDLE,
    refetch: async () => {
      return undefined
    },
  },
  customerSpecInfo: {
    data: [],
    progress: Progress.IDLE,
    refetch: async () => {
      return undefined
    },
  },
})

export function SpecsProvider({ children }: any) {
  const { id } = useParams()
  const { deal } = useDealContext()
  const {
    progress: specProgress,
    data: specifications = [],
    refetch: specificationRefetch,
  } = useTableData<SellerSpec>(endpoints.sellerSpecification(id), defaultListRequestParams, true)

  const sellerSpecInfo = useMemo(
    () => ({ progress: specProgress, data: specifications, refetch: specificationRefetch }),
    [specProgress, specifications, specificationRefetch],
  )

  const [progressPurchase, specsForPurchase = [], purchaseRefetch] = useSingleEntity<SpecificationsForPurchase[]>(
    endpoints.specificationForPurchase(deal.purchase_bid.owner.id, deal?.product?.slug),
  )

  const customerSpecInfo = useMemo(
    () => ({ progress: progressPurchase, data: specsForPurchase, refetch: purchaseRefetch }),
    [progressPurchase, specsForPurchase, purchaseRefetch],
  )

  return <SpecsContext.Provider value={{ sellerSpecInfo, customerSpecInfo }}>{children}</SpecsContext.Provider>
}
